export default {
  state: {
    text: 'moduleB'
  },
  getters: {},
  mutations: {
    setText (state) {
      state.text = "A"
    }
  },
  actions: {}
}
